import React, { createContext, useContext, useEffect, useState } from 'react';
import { authApi } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem('fc_token');
      if (token) {
        try {
          const u = await authApi.me();
          setUser(u);
        } catch (e) {
          localStorage.removeItem('fc_token');
        }
      }
      setLoading(false);
    })();
  }, []);

  const login = async (email, password) => {
    const { token, user } = await authApi.login(email, password);
    localStorage.setItem('fc_token', token);
    setUser(user);
    return user;
  };
  const logout = () => {
    localStorage.removeItem('fc_token');
    setUser(null);
    window.location.href = '/login';
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
